module.exports = __webpack_public_path__ + "img/download-tile-bg-desktop_cn.bef6592.jpg";